import { render, staticRenderFns } from "./VesselCurrentAIS.vue?vue&type=template&id=67b7442a&scoped=true&"
import script from "./VesselCurrentAIS.vue?vue&type=script&lang=js&"
export * from "./VesselCurrentAIS.vue?vue&type=script&lang=js&"
import style0 from "./VesselCurrentAIS.vue?vue&type=style&index=0&id=67b7442a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b7442a",
  null
  
)

export default component.exports